import React, { FC, SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface GreenCheckCircleFilledIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  fillColor?: string;
}

const GreenCheckCircleFilledIcon: FC<GreenCheckCircleFilledIconProps> = ({
  width = 24,
  height = 24,
  fillColor = '#16A34A'
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.39999C8.35473 5.39999 5.39978 8.35493 5.39978 12C5.39978 15.6451 8.35473 18.6 12 18.6C15.6453 18.6 18.6 15.6451 18.6 12C18.6 8.35493 15.6453 5.39999 12 5.39999ZM15.124 10.6241C15.3584 10.3899 15.3584 10.0101 15.124 9.77599C14.8899 9.54188 14.5101 9.54188 14.276 9.77599L10.7997 13.2523L9.72404 12.1766C9.48992 11.9425 9.11018 11.9425 8.87604 12.1766C8.64191 12.4107 8.64191 12.7905 8.87604 13.0246L10.376 14.5246C10.6101 14.7587 10.9899 14.7587 11.224 14.5246L15.124 10.6241Z"
        fill="white"
      />
    </svg>
  </SVGUniqueID>
);

export { GreenCheckCircleFilledIcon };
